var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-card d-flex flex-column align-items-start justify-content-between mb-2",class:_vm.classes,style:({ borderWidth: _vm.status === 'not-completed' ? '4px' : '0', backgroundColor: _vm.status === 'not-completed' ? _vm.color : ''})},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }